define( [
	"./class2type"
], function( class2type ) {
	return class2type.toString;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/toString.js
// module id = 811
// module chunks = 2